// extracted by mini-css-extract-plugin
module.exports = {"decline-button":"_1AjHsFX1IvdZ8fXWFg-SJl","declineButton":"_1AjHsFX1IvdZ8fXWFg-SJl","ach-table":"_1JgpZMKLjKW-abrHixdV1Y","achTable":"_1JgpZMKLjKW-abrHixdV1Y"};